import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { mediaAPI } from '../../services/(adminapi)/mediaAPI'

// Async thunks
export const fetchMedia = createAsyncThunk(
  'media/fetchMedia',
  async (_, { rejectWithValue }) => {
    try {
      const response = await mediaAPI.getAllMedia()
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Failed to fetch media')
    }
  }
)

export const uploadMedia = createAsyncThunk(
  'media/uploadMedia',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await mediaAPI.uploadMedia(formData)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Failed to upload media')
    }
  }
)

const initialState = {
  media: [],
  loading: false,
  uploading: false,
  error: null,
  success: null
}

const mediaSlice = createSlice({
  name: 'media',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    clearSuccess: (state) => {
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch media
      .addCase(fetchMedia.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchMedia.fulfilled, (state, action) => {
        state.loading = false
        if (action.payload.success) {
          state.media = action.payload.data || []
        }
        state.error = null
      })
      .addCase(fetchMedia.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
        state.media = []
      })
      
      // Upload media
      .addCase(uploadMedia.pending, (state) => {
        state.uploading = true
        state.error = null
        state.success = null
      })
      .addCase(uploadMedia.fulfilled, (state, action) => {
        state.uploading = false
        if (action.payload.success) {
          state.success = 'Media uploaded successfully'
          // Optionally add to media list or refresh
        }
        state.error = null
      })
      .addCase(uploadMedia.rejected, (state, action) => {
        state.uploading = false
        state.error = action.payload
      })
  }
})

export const { clearError, clearSuccess } = mediaSlice.actions
export default mediaSlice.reducer

